import React from 'react'
import SmsIcon from '@material-ui/icons/Sms'

const icon = () => <SmsIcon />

export default icon
